module.exports = __webpack_public_path__ + "img/appNew.21247e68.png";